import {
  FETCH_CHART_BOARD,
  FETCH_CHART_BOARD_SUCCESS,
  FETCH_CHART_BOARD_FAILURE,
} from "./constants";

const initialState = {
  isFetching: false,
  tiles: [],
  residents: [],
  residentsTotal: 0,
  range: null,
  locationId: null,
  error: null,
};

const ChartBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CHART_BOARD:
      return { ...state, isFetching: true, error: null };
    case FETCH_CHART_BOARD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        tiles: action.payload?.tiles ?? [],
        residents: action.payload?.residents ?? [],
        residentsTotal: action.payload?.residentsTotal ?? 0,
        range: action.payload?.range ?? null,
        locationId: action.payload?.locationId ?? null,
      };
    case FETCH_CHART_BOARD_FAILURE:
      return { ...state, isFetching: false, error: true };
    default:
      return state;
  }
};

export default ChartBoardReducer;
